import type redux from 'redux';
import { LANGUAGE_SET } from './actions';

export interface ILanguageState {
    code: string;
}

function language(
    state: ILanguageState = { code: sessionStorage.getItem('languageCode') || 'nl' },
    action: any = {}
): ILanguageState {
    switch (action.type) {
        case LANGUAGE_SET:
            sessionStorage.setItem('languageCode', action.code);

            return {
                code: action.code,
            };
        default:
            return state;
    }
}

export const rootReducer: redux.Reducer<ILanguageState> = language;
